export function formatDateTime(dateTime) {
    if (!dateTime)
        return "";
    if (typeof dateTime === 'string') {
        dateTime = new Date(Date.parse(dateTime));
    }
    const hour = dateTime.getHours().toString().padStart(2, "0");
    const minutes = dateTime.getMinutes().toString().padStart(2, "0");
    const timeString = `${hour}:${minutes}`;
    return `${formatDate(dateTime)}, ${timeString}`;
}
export function formatDateTimeShort(dateTime) {
    if (!dateTime)
        return "";
    if (typeof dateTime === 'string') {
        dateTime = new Date(Date.parse(dateTime));
    }
    const hour = dateTime.getHours().toString().padStart(2, "0");
    const minutes = dateTime.getMinutes().toString().padStart(2, "0");
    const timeString = `${hour}:${minutes}`;
    return `${formatDateShort(dateTime)} ${timeString}`;
}
export function formatDateUtc(date) {
    if (!date)
        return "";
    if (typeof date === 'string') {
        date = new Date(Date.parse(date));
    }
    const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    const day = date.getUTCDate().toString().padStart(2, "0");
    const year = date.getUTCFullYear();
    return [day, month, year].join('.');
}
export function formatDate(date) {
    if (!date)
        return "";
    if (typeof date === 'string') {
        date = new Date(Date.parse(date));
    }
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return [day, month, year].join('.');
}
export function formatDateShort(date) {
    if (!date)
        return "";
    if (typeof date === 'string') {
        date = new Date(Date.parse(date));
    }
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear() - 2000;
    return [day, month, year].join('.');
}
export function weekOfTheYear(date) {
    if (!date)
        return "";
    if (typeof date === 'string') {
        date = new Date(Date.parse(date));
    }
    const onejan = new Date(date.getFullYear(), 0, 1);
    const week = Math.ceil((((date.getTime() - onejan.getTime()) / 86400000) + onejan.getDay() + 1) / 7);
    const year = date.getFullYear().toString().substring(2);
    return `${year}${week}`;
}
